__turbopack_context__.v({
  "accent": "size-advisor-module-scss-module__JV-B4G__accent",
  "actions": "size-advisor-module-scss-module__JV-B4G__actions",
  "body": "size-advisor-module-scss-module__JV-B4G__body",
  "box": "size-advisor-module-scss-module__JV-B4G__box",
  "caption": "size-advisor-module-scss-module__JV-B4G__caption",
  "close": "size-advisor-module-scss-module__JV-B4G__close",
  "dialog": "size-advisor-module-scss-module__JV-B4G__dialog",
  "error": "size-advisor-module-scss-module__JV-B4G__error",
  "explain": "size-advisor-module-scss-module__JV-B4G__explain",
  "eyebrow": "size-advisor-module-scss-module__JV-B4G__eyebrow",
  "field": "size-advisor-module-scss-module__JV-B4G__field",
  "fields": "size-advisor-module-scss-module__JV-B4G__fields",
  "form": "size-advisor-module-scss-module__JV-B4G__form",
  "help": "size-advisor-module-scss-module__JV-B4G__help",
  "help-note": "size-advisor-module-scss-module__JV-B4G__help-note",
  "help-text": "size-advisor-module-scss-module__JV-B4G__help-text",
  "help-title": "size-advisor-module-scss-module__JV-B4G__help-title",
  "image": "size-advisor-module-scss-module__JV-B4G__image",
  "input": "size-advisor-module-scss-module__JV-B4G__input",
  "intro": "size-advisor-module-scss-module__JV-B4G__intro",
  "label": "size-advisor-module-scss-module__JV-B4G__label",
  "layout": "size-advisor-module-scss-module__JV-B4G__layout",
  "lead": "size-advisor-module-scss-module__JV-B4G__lead",
  "list": "size-advisor-module-scss-module__JV-B4G__list",
  "note": "size-advisor-module-scss-module__JV-B4G__note",
  "ok": "size-advisor-module-scss-module__JV-B4G__ok",
  "photo": "size-advisor-module-scss-module__JV-B4G__photo",
  "popup": "size-advisor-module-scss-module__JV-B4G__popup",
  "popup-title": "size-advisor-module-scss-module__JV-B4G__popup-title",
  "progress": "size-advisor-module-scss-module__JV-B4G__progress",
  "result": "size-advisor-module-scss-module__JV-B4G__result",
  "saved": "size-advisor-module-scss-module__JV-B4G__saved",
  "size": "size-advisor-module-scss-module__JV-B4G__size",
  "sizes": "size-advisor-module-scss-module__JV-B4G__sizes",
  "step": "size-advisor-module-scss-module__JV-B4G__step",
  "sub": "size-advisor-module-scss-module__JV-B4G__sub",
  "submit": "size-advisor-module-scss-module__JV-B4G__submit",
  "title": "size-advisor-module-scss-module__JV-B4G__title",
  "top": "size-advisor-module-scss-module__JV-B4G__top",
  "unit": "size-advisor-module-scss-module__JV-B4G__unit",
  "veil": "size-advisor-module-scss-module__JV-B4G__veil",
  "x": "size-advisor-module-scss-module__JV-B4G__x",
});
